import type { SearchSource } from "@lupp/shared";

/**
 * Deduplicate sources for DISPLAY only (the persisted data structure is untouched):
 * multiple retrieval chunks of the same file/page collapse to one source. The key is
 * the OWUI `file_id` (fallback `hash`). Sources with NEITHER file_id nor hash (e.g. web
 * results) are never merged — every one is shown.
 */
export function dedupeSourcesForDisplay(sources: SearchSource[]): SearchSource[] {
  const seen = new Set<string>();
  const out: SearchSource[] = [];
  for (const s of sources) {
    const key = s.fileId ?? s.hash;
    if (!key) {
      out.push(s); // no file/hash → always shown
      continue;
    }
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(s);
  }
  return out;
}
